export const functionLabels: Record<string, string> = {
  ClientProcess: "Quản lý tiến trình",
  ClientApplication: "Quản lý Ứng dụng",
  ClientOpenedPort: "Quản lý cổng mở",
  ClientCommand: "Chạy lệnh hệ thống",
  ClientDumpCredential: "Thu thập thông tin xác thực của hệ điều hành",
  ClientBrowserCredential: "Thu thập thông tin xác thực của trình duyệt",
  ClientKeylogger: "Ghi phím và clipboard",
  ClientScreenshot: "Chụp màn hình",
  ClientInfo: "Thông tin hệ thống",
  ClientRecon: "Thu thập thông tin hệ thống",
  ClientFindDML: "Tìm DLL Missing và Hijackable COM",
  ClientNmap: "Quét và lập sơ đồ mạng",
  ClientBruteForce: "Dò quét mật khẩu trong mạng nội bộ",
  ClientLolBin: "Chạy mã qua Windows binary có sẵn (LoLBin)",
  ClientKillAV: "Vô hiệu hóa phần mềm diệt virus (Kill AV)",
};

export const clientFunctionCategories = [
  { id: "system", title: "Quản lý hệ thống", routes: ["ClientInfo", "ClientExplorer", "ClientProcess", "ClientApplication", "ClientOpenedPort", "ClientCommand", "ClientInject", "ClientKillAV"] },
  { id: "credentials", title: "Đánh cắp mật mã & xác thực", routes: ["ClientDumpCredential", "ClientBrowserCredential"] },
  { id: "surveillance", title: "Giám sát & ghi lại hoạt động", routes: ["ClientKeylogger", "ClientScreenshot", "ClientRecord"] },
  { id: "reconnaissance", title: "Thu thập thông tin môi trường và lan truyền nội bộ", routes: ["ClientRecon", "ClientFindDML", "ClientNmap", "ClientBruteForce", "ClientLolBin"] },
  // Settings is the only destination left here: it opens the settings page itself.
  { id: "management", title: "Cấu hình, cài đặt", routes: ["ClientSetting"] },
] as const;

export type ClientFunctionCategory = typeof clientFunctionCategories[number]["id"];
